<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <header class="navbar">
    <div class="navbar__inner">
      <!-- 左侧 Logo + 文字 -->
      <router-link to="/" class="navbar__logo">
        <img src="@/assets/logo.png" alt="绿豚陪诊" />
        <span class="navbar__logo-text">绿豚陪诊</span>
      </router-link>

      <!-- 中间导航（绝对居中） -->
      <nav class="navbar__nav">
        <router-link to="/" class="navbar__link" exact-active-class="is-active">
          <span class="navbar__link-text">首页</span>
        </router-link>
        <router-link to="/services" class="navbar__link">
          <span class="navbar__link-text">核心业务</span>
        </router-link>
        <router-link to="/team" class="navbar__link">
          <span class="navbar__link-text">招商合作</span>
        </router-link>
        <router-link to="/qualification" class="navbar__link">
          <span class="navbar__link-text">项目案例</span>
        </router-link>
        <router-link to="/activities" class="navbar__link">
          <span class="navbar__link-text">活动动态</span>
        </router-link>
        <router-link to="/contact" class="navbar__link">
          <span class="navbar__link-text">联系我们</span>
        </router-link>
          <router-link to="/tender" class="navbar__link">
              <span class="navbar__link-text">招标信息</span>
          </router-link>
      </nav>

      <!-- 右侧：微信公众号 + 前往后台管理（后台按钮在最右） -->
      <div class="navbar__right">
        <!-- 微信公众号 -->
        <div class="navbar__wechat">
          <div class="navbar__wechat-trigger">
            <span class="navbar__wechat-icon">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M8.5 4C4.9 4 2 6.6 2 9.8c0 1.8 1 3.4 2.5 4.5l-.6 2 2.2-1.2c.7.2 1.5.3 2.4.3h.5c-.1-.4-.2-.9-.2-1.4 0-3.1 2.9-5.6 6.6-5.6h.5C15.5 5.9 12.3 4 8.5 4zm-2.3 3.4c.5 0 .9.4.9.9s-.4.9-.9.9-.9-.4-.9-.9.4-.9.9-.9zm4.6 0c.5 0 .9.4.9.9s-.4.9-.9.9-.9-.4-.9-.9.4-.9.9-.9z"/>
                <path d="M22 14.3c0-2.7-2.5-4.8-5.6-4.8s-5.6 2.1-5.6 4.8 2.5 4.8 5.6 4.8c.7 0 1.3-.1 1.9-.3l1.8 1-.5-1.6c1.4-.9 2.4-2.3 2.4-3.9zm-7.5-1.1c.4 0 .8.3.8.8 0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.4-.8.8-.8zm3.8 0c.4 0 .8.3.8.8 0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.4-.8.8-.8z"/>
              </svg>
            </span>
            <span class="navbar__wechat-text">微信公众号</span>
          </div>

          <div class="navbar__qrcode">
            <img
                src="https://ltfxpz.oss-cn-shanghai.aliyuncs.com/%E7%BB%BF%E8%B1%9A%E9%99%AA%E8%AF%8A%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.jpg"
                alt="绿豚陪诊公众号二维码"
            />
            <p>扫码关注公众号</p>
          </div>
        </div>

        <!-- 前往后台管理（外部系统，新窗口打开） -->
        <a
            class="navbar__admin"
            href="http://118.178.196.229:3233/login"
            target="_blank"
            rel="noopener noreferrer"
        >
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none"
               stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="3" width="7" height="7" rx="1"/>
            <rect x="14" y="3" width="7" height="7" rx="1"/>
            <rect x="3" y="14" width="7" height="7" rx="1"/>
            <rect x="14" y="14" width="7" height="7" rx="1"/>
          </svg>
          <span>前往后台管理</span>
        </a>
      </div>
    </div>
  </header>
</template>

<script setup>
// 纯展示
</script>

<style scoped>
/* ===== 导航栏外框 ===== */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.navbar__inner {
    position: relative;
    /* max-width: 1440px; 👈 删掉或者注释掉这行代码 */
    width: 100%;          /* 👈 确保宽度占满 100% */
    margin: 0;            /* 👈 确保没有外边距 */
    height: 96px;
    padding: 13px;           /* 👈 把原本的 0 40px 改成 0，取消左右留白 */
    display: flex;
    align-items: center;
    justify-content: space-between; /* 左边贴左，右边贴右 */
}

/* ===== 左侧 Logo ===== */
.navbar__logo {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-shrink: 0;
    text-decoration: none;

    /* 👇 单独控制左边 Logo 的位置 */
    margin-left: 47px; /* 数值越大，Logo 往右走得越多；如果不想用 margin，用 padding-left: 30px; 效果一样 */
}
.navbar__logo img {
  height: 56px;
  width: auto;
  object-fit: contain;
}
.navbar__logo-text {
  font-size: 22px;
  font-weight: 700;
  color: var(--gt-primary);
  letter-spacing: 1px;
  white-space: nowrap;
}

/* ===== 中间导航 ===== */
.navbar__nav {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%); /* 👈 这三行是绝对居中的魔法 */
    display: flex;
    align-items: center;
    gap: 28px; /* 👈 间距可以稍微拉开一点，比如 26px 或 28px，看起来更舒展 */
    white-space: nowrap;
}

.navbar__link {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
  text-decoration: none;
}

.navbar__link-text {
  font-size: 17px;
  color: #1f2d3d;
  font-weight: 500;
  transition: color 0.25s, font-weight 0.25s;
}

.navbar__link:hover .navbar__link-text {
  color: var(--gt-primary);
}

/* 选中态（含默认 router-link-active，修复非首页无选中态） */
.navbar__link.is-active .navbar__link-text,
.navbar__link.router-link-active .navbar__link-text {
  color: var(--gt-primary);
  font-weight: 600;
}

.navbar__link.is-active::after,
.navbar__link.router-link-active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translateX(-50%);
  width: 24px;
  height: 3px;
  background: var(--gt-primary);
  border-radius: 3px;
}
.navbar__link.is-active::before,
.navbar__link.router-link-active::before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -22px;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  background: var(--gt-primary);
  border-radius: 50%;
  opacity: 0.7;
}

/* 悬停时的下划线（淡入） */
.navbar__link:not(.is-active):not(.router-link-active)::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translateX(-50%) scaleX(0);
  width: 24px;
  height: 3px;
  background: var(--gt-primary);
  border-radius: 3px;
  opacity: 0;
  transition: transform 0.25s, opacity 0.25s;
}
.navbar__link:not(.is-active):not(.router-link-active):hover::after {
  transform: translateX(-50%) scaleX(1);
  opacity: 1;
}

/* ===== 右侧区域：公众号 + 后台按钮 ===== */
.navbar__right {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;
    height: 100%;
    /* 不要加 margin-left: auto; 因为外层已经 space-between 了 */
}

/* 前往后台管理：描边胶囊，悬停填充实心绿 + 白字 */
.navbar__admin {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
  color: #12B886;                    /* 默认绿字（写死，不依赖变量） */
  background: transparent;
  border: 1px solid #12B886;
  border-radius: 999px;
  text-decoration: none;
  white-space: nowrap;
  transition: color .25s, background-color .25s, border-color .25s,
  box-shadow .25s, transform .25s;
}
.navbar__admin:hover {
  color: #fff;
  background-color: #12B886;         /* ★ 写死背景色，确保 hover 一定可见 */
  border-color: #12B886;
  box-shadow: 0 6px 16px rgba(18, 184, 134, .25);
  transform: translateY(-1px);
}
.navbar__admin:active {
  transform: translateY(0);
}
.navbar__admin svg {
  flex-shrink: 0;
}

/* ===== 微信公众号 ===== */
.navbar__wechat {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
}
.navbar__wechat-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--gt-secondary);
  transition: color 0.25s;
}
.navbar__wechat:hover .navbar__wechat-trigger {
  color: var(--gt-secondary-dark);
}
.navbar__wechat-icon {
  display: flex;
  align-items: center;
  color: var(--gt-secondary);
}
.navbar__wechat-text {
  font-size: 16px;
  font-weight: 500;
  color: var(--gt-secondary);
}
.navbar__wechat:hover .navbar__wechat-text {
  color: var(--gt-secondary-dark);
}

/* 二维码弹窗 */
.navbar__qrcode {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 14px;
  background: #fff;
  border-radius: 14px;
  padding: 24px 28px;
  min-width: 240px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.14);
  text-align: center;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s;
  pointer-events: none;
}
.navbar__qrcode::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 40px;
  width: 12px;
  height: 12px;
  background: #fff;
  transform: rotate(45deg);
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.04);
}
.navbar__wechat:hover .navbar__qrcode {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
}
.navbar__qrcode img {
  width: 180px;
  height: 180px;
  object-fit: contain;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
  background: #fff;
}
.navbar__qrcode p {
  margin-top: 12px;
  font-size: 14px;
  color: #4a5a6a;
  font-weight: 500;
}

/* ===== 响应式 ===== */
@media (max-width: 1360px) {
    .navbar__nav { gap: 20px; margin-left: 30px; } /* 屏幕变小时，间距和左边缘缩短 */
    .navbar__link-text { font-size: 16px; }
    .navbar__logo-text { font-size: 20px; }
    .navbar__right { gap: 16px; }
    .navbar__admin { padding: 8px 15px; font-size: 14px; }
}
@media (max-width: 1024px) {
  .navbar__nav { gap: 22px; }
  .navbar__link-text { font-size: 15px; }
}
@media (max-width: 900px) {
  .navbar__inner { height: 72px; padding: 0 20px; }
  .navbar__logo img { height: 44px; }
  .navbar__logo-text { font-size: 18px; }
  .navbar__nav { position: static; transform: none; display: none; }
  .navbar__wechat-text { display: none; }
  .navbar__right { gap: 12px; }
  .navbar__admin { padding: 7px 12px; font-size: 13px; }
}
@media (max-width: 600px) {
  /* 后台管理主要供 PC 运营使用，移动端可直接隐藏；如需保留，删除这段即可 */
  .navbar__admin { display: none; }
}
</style>
